import { useCallback } from 'react';
import { useAuth } from '@dofleini/security';
import { useDialogsContext } from '@/contexts/DialogsContext';
import { DIALOG_NAMESPACE } from '@/components/NewEmailDialog';
import { NOTIFICATION_DRAWER } from '@/components/NotificationDrawer';
import { useHistory } from 'react-router-dom';

export default () => {
  const { logout } = useAuth();
  const { openDialog: showEmail } = useDialogsContext(DIALOG_NAMESPACE);
  const { openDialog: showNotifications } = useDialogsContext(NOTIFICATION_DRAWER);
  /*const { openDialog: showProfile } = useDetailsContext(NAME);*/
  const { push } = useHistory();
  
  return useCallback(({ action }) => {
    switch (action) {
      case 'LOGOUT':
        logout();
        break;
      case 'NOTIFICATIONS':
        showNotifications();
        break;
      case 'SENDMAIL':
        showEmail();
        break;
      case 'PROFILE':
        push('/profile/personal');
        break;
      default:
        break;
    }
  }, [logout, push, showNotifications, showEmail]);
};
